// Promo Card State

export default {
  promoCardList: [],
  promoCardInfo: {}
}
